import React, { useState, useEffect } from 'react';
import { Progress, Icon } from 'antd';
import { FaHourglassStart, FaCalculator } from 'react-icons/fa';

const color = '#3378f9';
let interval;

const LoaderIcon = ({ hasProgress, hasCounting, ...props }) => {
  const [percentage, setPercentage] = useState(0);

  useEffect(() => {
    if (hasProgress) {
      interval = setInterval(() => {
        setPercentage((oldPercentage) => {
          if (oldPercentage >= 100) {
            clearInterval(interval);
            return 100;
          }
          return oldPercentage + 100 / (110 / 2);
        });
      }, 2000);
    } else {
      clearInterval(interval);
      setPercentage(0);
    }

    return () => clearInterval(interval);
  }, [hasProgress]);

  const iconProps = {
    spin: true,
    style: { fontSize: '24px', color },
    component: hasCounting ? FaCalculator : FaHourglassStart,
  };

  const icon = <Icon {...iconProps} {...props} />;

  return hasProgress ? (
    <Progress
      percent={percentage}
      width={70}
      type="circle"
      strokeColor={color}
      format={() => icon}
    />
  ) : (
    icon
  );
};

export default LoaderIcon;
